import { Portlet, TabPortlet } from '@cms/tpl';
import { ICONS } from 'common';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import DataMappingType from 'types/DataMappingType';
import Service from '../Service';
import Detail from './Detail';
import UserMappingTab from './UserMappingTab';

const DelegateDetail = ({ created = false }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ delegateId: '' });
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get('id');

  useEffect(() => {
    if (!created) {
      setLoading(true);
      Service.get(id)
        .then((resp) => {
          // @ts-ignore
          setData(resp.item);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);
  return (
    <React.Fragment>
      {created ? (
        <Portlet title='Tạo người đại diện' icon={ICONS.PlusOutlined}>
          <Detail create={true} />
        </Portlet>
      ) : (
        <TabPortlet
          renderTabs={[
            {
              title: 'Thông tin người đại diện',
              body: <Detail loading={loading} data={data} create={created} />,
            },
            {
              title: 'Nguời quản lý',
              body: (
                <UserMappingTab
                  dataId={data.delegateId}
                  type={DataMappingType.DELEGATE_MAP_USER_MANAGER}
                />
              ),
            },
          ]}
        />
      )}
    </React.Fragment>
  );
};

export default DelegateDetail;
